// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a4PZu","content":"styles_content__3GK0W","tableWrap":"styles_tableWrap__1vISe"};